import type { DogShelterWhereInput } from '@gql/graphql';
import type { ShelterListPageFormValues } from '@presentation/pages';
import { useCallback } from 'react';

export const useShelterWhereBuilder = () => {
  const shelterWhereBuilder = useCallback(
    (form?: ShelterListPageFormValues): DogShelterWhereInput => {
      const whereInputs: DogShelterWhereInput[] = [];

      if (form) {
        if (form.countries?.length) {
          whereInputs.push({
            address: {
              is: {
                country: { in: form.countries },
              },
            },
          });
        }

        if (form.spokenLanguages && form.spokenLanguages.length > 0) {
          whereInputs.push({
            spokenLanguages: { hasSome: form.spokenLanguages },
          });
        }

        if (form.regions?.length) {
          whereInputs.push({
            address: { is: { region: { in: form.regions } } },
          });
        }
        return { AND: whereInputs };
      }
      return {};
    },
    [],
  );

  return { shelterWhereBuilder };
};
